const PERCENT_UNITS = new Set(["%", "percent", "percentage", "pct"]);
const COUNT_UNITS = new Set([
  "base",
  "count",
  "counts",
  "n",
  "people",
  "respondents",
  "responses",
  "sample",
]);

export function formatAnalystValue(value: number, unit: string): string {
  const normalizedUnit = unit.trim().toLowerCase();
  const isPercent = PERCENT_UNITS.has(normalizedUnit);
  const maximumFractionDigits = COUNT_UNITS.has(normalizedUnit)
    ? 0
    : isPercent
      ? 1
      : 2;
  const formatted = new Intl.NumberFormat(undefined, {
    maximumFractionDigits,
  }).format(value);

  return isPercent ? `${formatted}%` : formatted;
}
